export default __webpack_public_path__ + "static/media/NCVietnam.b81c7cf6.png";